const DR_PAYMENT_CALC_INTERACTION_MAP = {
	'Build Your Offer Toggle': 'Click',
	'Down Payment Field': 'Fill',
	'Estimate Trade-in Value Field': 'Fill',
	'Get Trade-in Value Link': 'Click',
	'Amount Owed Field': 'Fill',
	'Credit Rating Dropdown': 'Select',
	'Term Length Dropdown': 'Select',
	'Get Taxes and Fees Link': 'Click',
	'Apply For Financing Link': 'Click',
	'Offer Breakdown Accordion': 'Click'
};

const DR_PAYMENT_CALC_FINISH_MAP = {
	'Continue Deal Primary Button': 'Click',
	'Continue Deal Secondary Button': 'Click'
};

export default {
	events: {
		widgetUserEvent: [
			{
				logic: ({ eventData: { eventName } }) =>
					eventName === 'Shopper Platform Init' &&
					window.location.search.includes('autoOpen=true'),
				payload: {},
				fireGroup: 'sdpInit',
				trigger: 'drInitialClick'
			},
			{
				logic: [
					{
						eventName: 'DR_PAYMENT_TYPE_CHANGED'
					},
					{
						eventName: 'DR_DOWN_PAYMENT_CHANGED'
					},
					{
						eventName: 'DR_CREDIT_TIER_CHANGED'
					},
					{
						eventName: 'DR_PAYMENT_TERM_CHANGED'
					},
					{
						eventName: 'DR_LEASE_ANNUAL_MILES_CHANGED'
					},
					{
						eventName: 'DR_LEASE_ANNUAL_MILES_CHANGED'
					}
				],
				payload: {
					events: 'drPaymentCalcInteraction',
					digRet: '[[mapping.configuration.sharedPayloads.drVehicleData]]'
				},
				fireGroup: 'accelerateInitialCalcStart',
				trigger: 'drInitialClick'
			},
			{
				logic: [
					{
						eventName: 'DR_PAYMENT_TYPE_CHANGED'
					},
					{
						eventName: 'DR_DOWN_PAYMENT_CHANGED'
					},
					{
						eventName: 'DR_CREDIT_TIER_CHANGED'
					},
					{
						eventName: 'DR_PAYMENT_TERM_CHANGED'
					},
					{
						eventName: 'DR_LEASE_ANNUAL_MILES_CHANGED'
					},
					{
						eventName: 'DR_LEASE_ANNUAL_MILES_CHANGED'
					}
				],
				payload: {
					events: 'drPaymentCalcInteraction',
					digRet: '[[mapping.configuration.sharedPayloads.drDataWithNewProps]]'
				},
				trigger: 'drInitialClick'
			},
			{
				logic: {
					eventName: 'DR_CONTINUE_TO_SDP_CLICKED'
				},
				payload: {
					events: 'drPaymentCalcFinish',
					digRet: '[[mapping.configuration.sharedPayloads.drVehicleData]]'
				},
				trigger: 'drInitialClick',
				fireGroup: 'accelerateInitialCalcStart'
			},
			{
				logic: {
					eventName: 'DR_CONTINUE_TO_SDP_CLICKED'
				},
				payload: {
					events: 'drPaymentCalcFinish',
					digRet: '[[mapping.configuration.sharedPayloads.drDataWithNewProps]]'
				},
				trigger: 'drInitialClick'
			},
			{
				logic: [
					{
						eventName: 'DR_LEAD_FORM_FIRSTNAME_CHANGED'
					},
					{
						eventName: 'DR_LEAD_FORM_LASTNAME_CHANGED'
					},
					{
						eventName: 'DR_LEAD_FORM_EMAIL_CHANGED'
					},
					{
						eventName: 'DR_LEAD_FORM_PHONE_CHANGED'
					}
				],
				payload: {
					events: 'drLeadFormStart',
					digRet: '[[mapping.configuration.sharedPayloads.drDataWithNewProps]]'
				},
				trigger: 'drInitialClick',
				fireGroup: 'accelerateLeadFormStart'
			},
			{
				logic: {
					eventName: 'DR_OFFER_SUBMISSION_CLICKED'
				},
				payload: {
					events: 'drLeadFormFinish',
					digRet: '[[mapping.configuration.sharedPayloads.drDataWithNewProps]]'
				},
				trigger: 'drInitialClick'
			},
			{
				logic: {
					eventName: 'DR_TEST_DRIVE_REQUESTED'
				},
				payload: {
					events: 'drApptSchedFinish',
					digRet: '[[mapping.configuration.sharedPayloads.drDataWithNewProps]]'
				},
				trigger: 'drInitialClick'
			},
			{
				logic: {
					eventName: 'DR_TRADEIN_ESTIMATE_DISPLAYED'
				},
				payload: {
					events: 'drTradeInFinish',
					digRet: '[[mapping.configuration.sharedPayloads.drDataWithPriceUnlocked]]',
					isGTP: '[[fn.isGtp()]]'
				},
				trigger: 'drInitialClick'
			},
			{
				logic: {
					eventName: 'DR_CREDIT_APP_SUCCESS_DISPLAYED'
				},
				payload: {
					events: 'drCreditAppFinish',
					digRet: '[[mapping.configuration.sharedPayloads.drDataWithNewProps]]'
				},
				trigger: 'drInitialClick'
			},
			{
				logic: {
					eventName: 'DR_SHOPPER_COMPLETES_MENU_PRODUCTS'
				},
				payload: {
					events: 'drFiFinish',
					digRet: '[[mapping.configuration.sharedPayloads.drDataWithNewProps]]'
				},
				trigger: ['drInitialClick']
			},
			{
				logic: {
					eventName: 'DR_ACCESSORIES_CLOSE'
				},
				payload: {
					events: 'drAccessoriesFinish',
					digRet: '[[mapping.configuration.sharedPayloads.drDataWithNewProps]]'
				}
			},
			{
				logic: {
					eventName: 'DR_INCENTIVES_ADDED'
				},
				payload: {
					events: 'drOfferAdded',
					digRet: {
						shared: [
							'[[mapping.configuration.sharedPayloads.drDataWithNewProps]]'
						],
						offerName: '[[eventData.sourceData.incentives.name]]',
						offerType: '[[eventData.sourceData.dealType]]'
					}
				}
			},
			{
				logic: {
					eventName: 'DR_PAYMENT_DISPLAY'
				},
				payload: [
					{
						events: 'drImpression',
						digRet: {
							shared: [
								'[[mapping.configuration.sharedPayloads.drVehicleData]]'
							],
							priceUnlocked: true
						}
					},
					{
						events: 'drPaymentCalcShown',
						digRet: '[[mapping.configuration.sharedPayloads.drDataWithNewProps]]'
					}
				],
				fireGroup: 'drImpression'
			},
			{
				logic: {
					eventName: 'DR_SDP_LEAVE_BUTTON_CLICKED'
				},
				payload: {
					events: 'drDropSave',
					digRet: '[[mapping.configuration.sharedPayloads.drDataWithNewProps]]'
				},
				trigger: 'drInitialClick'
			},
			{
				logic: {
					eventName: 'DR_CREDIT_APP_DISPLAYED'
				},
				payload: {
					events: 'drCreditAppShown',
					digRet: '[[mapping.configuration.sharedPayloads.drDataWithNewProps]]'
				},
				fireGroup: 'drCreditAppShown'
			},
			{
				logic: {
					eventName: 'DR_CREDIT_APP_PERSONALINFO_PAGE_DISPLAYED'
				},
				payload: {
					events: 'drCreditAppStart',
					digRet: '[[mapping.configuration.sharedPayloads.drDataWithNewProps]]'
				}
			},
			{
				logic: [
					{
						eventName: 'DR_TRADEIN_VEHICLE_YEAR_CHANGED'
					},
					{
						eventName: 'DR_TRADEIN_VEHICLE_TRIM_CHANGED'
					},
					{
						eventName: 'DR_TRADEIN_SEARCHTYPE_CLICKED'
					},
					{
						eventName: 'DR_TRADEIN_VEHICLE_MILEAGE_CHANGED'
					},
					{
						eventName: 'DR_TRADEIN_VEHICLE_ZIPCODE_CHANGED'
					},
					{
						eventName: 'DR_TRADEIN_VEHICLE_OWNERSHIP_CHANGE'
					}
				],
				payload: {
					events: 'drTradeInStart',
					digRet: {
						shared: [
							'[[mapping.configuration.sharedPayloads.drVehicleData]]'
						],
						priceUnlocked: true
					}
				},
				fireGroup: 'accelerateTradeInStart'
			},
			{
				logic: [
					{
						eventName: 'DR_TRADEIN_OPENED'
					}
				],
				payload: {
					events: 'drTradeInShown',
					digRet: '[[mapping.configuration.sharedPayloads.drDataWithNewProps]]'
				}
			},
			{
				logic: {
					eventName: 'DR_NAVIGATE_TO_VEHICLEPROTECTION'
				},
				payload: {
					events: 'drFiShown',
					digRet: '[[mapping.configuration.sharedPayloads.drDataWithNewProps]]'
				}
			},
			{
				logic: [
					{
						eventName: 'DR_LEAD_FORM_DISPLAYED'
					}
				],
				payload: {
					events: 'drLeadFormShown',
					digRet: '[[mapping.configuration.sharedPayloads.drDataWithNewProps]]'
				}
			},
			{
				logic: [
					{
						eventName: 'DR_NAVIGATE_TO_ACCESSORIES'
					}
				],
				payload: {
					events: 'drAccessoriesShown',
					digRet: '[[mapping.configuration.sharedPayloads.drDataWithNewProps]]'
				}
			},
			{
				logic: [
					{
						eventName: 'DR_MENU_PRODUCT_ADDED'
					},
					{
						eventName: 'DR_ACCESSORIES_ADDED'
					}
				],
				payload: ({ eventData }) => ({
					events: 'drAddToCart',
					digRet: {
						shared: [
							'[[mapping.configuration.sharedPayloads.drDataWithNewProps]]'
						],
						AddOnName: eventData.sourceData?.menuProduct?.name,
						AddOnType:
							eventData.sourceData.menuProduct.type ===
							'VehicleProtection'
								? 'FI'
								: eventData.sourceData.menuProduct.type
					}
				})
			},
			{
				logic: {
					eventName: 'DR_NAVIGATE_TO_TESTDRIVE'
				},
				payload: {
					events: 'drApptSchedShown',
					digRet: '[[mapping.configuration.sharedPayloads.drDataWithNewProps]]'
				}
			},
			{
				logic: [
					{
						eventName: 'DR_APPOINTMENT_TYPE_CLICKED'
					},
					{
						eventName: 'DR_TEST_DRIVE_LOCATION_CLICKED'
					},
					{
						eventName: 'DR_TEST_DRIVE_TIME_SELECTED'
					},
					{
						eventName: 'DR_TEST_DRIVE_DATE_SELECTED'
					}
				],
				payload: {
					events: 'drApptSchedStart',
					digRet: '[[mapping.configuration.sharedPayloads.drDataWithNewProps]]'
				}
			}
		],
		commonDataLayerEvent: [
			{
				logic: ({ eventData, flags }) =>
					flags['ws-tagging-enable-uds-on-shiftdr'] &&
					eventData?.event?.element === 'UDS Component' &&
					eventData?.event?.action === 'Impression',
				payload: [
					{
						events: 'drImpression',
						digRet: {
							shared: [
								'[[mapping.configuration.sharedPayloads.drVehicleData]]'
							],
							priceUnlocked: true
						}
					}
				],
				fireGroup: 'drImpression'
			},
			{
				logic: ({ eventData, flags }) =>
					flags['ws-tagging-enable-uds-on-shiftdr'] &&
					eventData?.event?.element === 'UDS Component' &&
					eventData?.event?.action === 'Initial Click',
				payload: {
					events: 'drInitialClick',
					digRet: {
						shared: [
							'[[mapping.configuration.sharedPayloads.drVehicleData]]'
						],
						priceUnlocked: true
					}
				},
				configuration: {
					count: 1,
					when: 'first'
				},
				fireGroup: 'drInitialClick'
			},
			{
				logic: ({ eventData, flags }) =>
					flags['ws-tagging-enable-uds-on-shiftdr'] &&
					eventData?.event?.element === 'UDS Component' &&
					eventData?.event?.action === 'View',
				payload: {
					events: 'drPaymentCalcShown',
					digRet: {
						shared: [
							'[[mapping.configuration.sharedPayloads.drVehicleData]]'
						],
						priceUnlocked: true
					}
				}
			},
			{
				logic: ({ eventData, flags }) =>
					flags['ws-tagging-enable-uds-on-shiftdr'] &&
					eventData?.event?.element &&
					eventData?.event?.action &&
					DR_PAYMENT_CALC_INTERACTION_MAP[
						eventData?.event?.element
					] === eventData?.event?.action,
				payload: {
					events: 'drPaymentCalcInteraction',
					digRet: {
						shared: [
							'[[mapping.configuration.sharedPayloads.drDataWithNewProps]]'
						],
						priceUnlocked: true
					}
				}
			},
			{
				logic: ({ eventData, flags }) =>
					flags['ws-tagging-enable-uds-on-shiftdr'] &&
					eventData?.event?.element &&
					eventData?.event?.action &&
					DR_PAYMENT_CALC_FINISH_MAP[eventData?.event?.element] ===
						eventData?.event?.action,
				payload: {
					events: 'drPaymentCalcFinish',
					digRet: {
						shared: [
							'[[mapping.configuration.sharedPayloads.drDataWithNewProps]]'
						],
						priceUnlocked: true
					}
				}
			}
		]
	},
	triggerEvents: {
		drInitialClick: {
			logic: {
				mustNotEqual: {
					'eventData.action': 'display'
				}
			},
			payload: {
				events: 'drInitialClick',
				digRet: {
					shared: [
						'[[mapping.configuration.sharedPayloads.drVehicleData]]'
					],
					priceUnlocked: true
				}
			},
			configuration: {
				count: 1,
				when: 'first'
			}
		}
	},
	fireGroups: {
		accelerateTradeInStart: {
			maxCount: 1
		},
		accelerateInitialCalcStart: {
			maxCount: 1
		},
		accelerateLeadFormStart: {
			maxCount: 1
		},
		drCreditAppShown: {
			maxCount: 1
		},
		drImpression: {
			maxCount: 1
		},
		drInitialClick: {
			maxCount: 1
		},
		sdpInit: {
			maxCount: 1
		}
	}
};
